import usePrivateAxios from "@/common/api/usePrivateAxios";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { FeeTemplateData, FeeTemplateResponse } from "../types/feeTemplates.type";

const useFeeTemplate: (id: string) => UseQueryResult<FeeTemplateData, unknown> = (id) => {
  const privateAxios = usePrivateAxios()

  return useQuery<FeeTemplateResponse, unknown, FeeTemplateData>({
    queryKey: ['feeTemplate', id],
    queryFn: () => {
      return privateAxios.get(`/billing/fee_templates/${id}`)
    },
    select: (data) => data?.data?.data
  });
}

export default useFeeTemplate